var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticStyle: { padding: "10px", color: "#d9d9d9" } }, [
        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_OcrTip")))
      ]),
      _c("div", { staticClass: "result-form-se" }, [
        _c(
          "div",
          {
            style: {
              cursor: "pointer",
              width: _vm.showBookRecognitionResults ? "100%" : "50%"
            }
          },
          [
            _c(
              "div",
              { staticClass: "row", staticStyle: { position: "relative" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "item1",
                    staticStyle: {
                      "font-weight": "bold",
                      color: "white",
                      "background-color": "#3f3f3f"
                    }
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_FieldName")))
                    ])
                  ]
                ),
                _vm.showBookRecognitionResults
                  ? _c(
                      "div",
                      {
                        staticClass: "item2",
                        staticStyle: {
                          "font-weight": "bold",
                          color: "white",
                          "background-color": "#3f3f3f"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BillResults")))]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "item3",
                    staticStyle: {
                      "font-weight": "bold",
                      color: "white",
                      "background-color": "#abd08e"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BillResults2")))]
                )
              ]
            ),
            _vm.currentOcrRecognitionFields &&
            _vm.currentOcrRecognitionFields.length > 0
              ? _c(
                  "div",
                  _vm._l(_vm.currentOcrRecognitionFields, function(item) {
                    return _c("div", { key: item.code }, [
                      _c("div", { staticStyle: { display: "none" } }, [
                        _vm._v(_vm._s(_vm.getValueBorderColor(item)))
                      ]),
                      _vm.showFieldItem(
                        item,
                        _vm.SystemConstants.OCR_FIELD_BILL_NO.code
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _vm.source ===
                                _vm.INTELLIGENT_DOCUMENT_SOURCE_5.code ||
                              _vm.source ===
                                _vm.INTELLIGENT_DOCUMENT_SOURCE_6.code
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "item1",
                                      style: { color: _vm.getFieldColor(item) }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("CargoMsg.Cargo_BLNo")) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              [
                                _vm.INTELLIGENT_DOCUMENT_SOURCE_7.code,
                                _vm.INTELLIGENT_DOCUMENT_SOURCE_16.code,
                                _vm.INTELLIGENT_DOCUMENT_SOURCE_8.code
                              ].includes(_vm.source)
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "item1",
                                      style: { color: _vm.getFieldColor(item) }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_SeparateNumber"
                                          )
                                        ) + " "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm.showBookRecognitionResults
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "item2",
                                      style: item.redColor ? "color:red" : ""
                                    },
                                    [_vm._v(_vm._s(_vm.resultJson[item.code]))]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "itemAssign" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.redColor,
                                        expression: "item.redColor"
                                      }
                                    ],
                                    staticClass: "itemAssign2",
                                    on: {
                                      click: function($event) {
                                        return _vm.itemAssignClick(item)
                                      }
                                    }
                                  },
                                  [_vm._v(" >> ")]
                                )
                              ]),
                              _c("el-input", {
                                staticClass: "item3",
                                class: { "input-red": item.redColor },
                                attrs: {
                                  disabled: _vm.fieldEditCheck(item.code)
                                },
                                model: {
                                  value: _vm.doc.billNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.doc, "billNo", $$v)
                                  },
                                  expression: "doc.billNo"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFieldItem(
                        item,
                        _vm.SystemConstants.OCR_FIELD_ORDER_TYPE.code
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.BLForm")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "item2",
                                      style: item.redColor ? "color:red" : ""
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.resultJson[item.code]) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "itemAssign" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.redColor,
                                        expression: "item.redColor"
                                      }
                                    ],
                                    staticClass: "itemAssign2",
                                    on: {
                                      click: function($event) {
                                        return _vm.itemAssignClick(item)
                                      }
                                    }
                                  },
                                  [_vm._v(" >> ")]
                                )
                              ]),
                              _c(
                                "el-select",
                                {
                                  staticClass: "item3",
                                  class: { "input-red": item.redColor },
                                  attrs: {
                                    placeholder: "",
                                    disabled: _vm.fieldEditCheck(item.code),
                                    no: "orderType",
                                    clearable: ""
                                  },
                                  on: {
                                    clear: function($event) {
                                      return _vm.clear(item)
                                    }
                                  },
                                  model: {
                                    value: _vm.doc.orderType,
                                    callback: function($$v) {
                                      _vm.$set(_vm.doc, "orderType", $$v)
                                    },
                                    expression: "doc.orderType"
                                  }
                                },
                                _vm._l(_vm.blModeList, function(item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.name,
                                      value: item.serialNumber
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFieldItem(
                        item,
                        _vm.SystemConstants.OCR_FIELD_BL_NUMBER.code
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_NumberOfOriginalCopies"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "item2",
                                      style: item.redColor ? "color:red" : ""
                                    },
                                    [_vm._v(_vm._s(_vm.resultJson[item.code]))]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "itemAssign" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.redColor,
                                        expression: "item.redColor"
                                      }
                                    ],
                                    staticClass: "itemAssign2",
                                    on: {
                                      click: function($event) {
                                        return _vm.itemAssignClick(item)
                                      }
                                    }
                                  },
                                  [_vm._v(" >> ")]
                                )
                              ]),
                              _c("el-input", {
                                staticClass: "item3",
                                class: { "input-red": item.redColor },
                                attrs: {
                                  disabled: _vm.fieldEditCheck(item.code)
                                },
                                model: {
                                  value: _vm.doc.blNumber,
                                  callback: function($$v) {
                                    _vm.$set(_vm.doc, "blNumber", $$v)
                                  },
                                  expression: "doc.blNumber"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFieldItem(
                        item,
                        _vm.SystemConstants.OCR_FIELD_SHIPPER.code
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("Message.Shipper")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("el-input", {
                                    staticClass: "item2",
                                    class: { "textarea-red": item.redColor },
                                    attrs: {
                                      disabled: "",
                                      rows: 6,
                                      type: "textarea"
                                    },
                                    model: {
                                      value: _vm.resultJson[item.code],
                                      callback: function($$v) {
                                        _vm.$set(_vm.resultJson, item.code, $$v)
                                      },
                                      expression: "resultJson[item.code]"
                                    }
                                  })
                                : _vm._e(),
                              _c("div", { staticClass: "itemAssign" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.redColor,
                                        expression: "item.redColor"
                                      }
                                    ],
                                    staticClass: "itemAssign2",
                                    on: {
                                      click: function($event) {
                                        return _vm.itemAssignClick(item)
                                      }
                                    }
                                  },
                                  [_vm._v(" >> ")]
                                )
                              ]),
                              _c("el-input", {
                                staticClass: "item3",
                                class: { "textarea-red": item.redColor },
                                attrs: {
                                  rows: 6,
                                  type: "textarea",
                                  disabled: _vm.fieldEditCheck(item.code)
                                },
                                model: {
                                  value: _vm.doc.shipper,
                                  callback: function($$v) {
                                    _vm.$set(_vm.doc, "shipper", $$v)
                                  },
                                  expression: "doc.shipper"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFieldItem(
                        item,
                        _vm.SystemConstants.OCR_FIELD_CONSIGNEE.code
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("Message.Consignee")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("el-input", {
                                    staticClass: "item2",
                                    class: { "textarea-red": item.redColor },
                                    attrs: {
                                      disabled: "",
                                      rows: 6,
                                      type: "textarea"
                                    },
                                    model: {
                                      value: _vm.resultJson[item.code],
                                      callback: function($$v) {
                                        _vm.$set(_vm.resultJson, item.code, $$v)
                                      },
                                      expression: "resultJson[item.code]"
                                    }
                                  })
                                : _vm._e(),
                              _c("div", { staticClass: "itemAssign" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.redColor,
                                        expression: "item.redColor"
                                      }
                                    ],
                                    staticClass: "itemAssign2",
                                    on: {
                                      click: function($event) {
                                        return _vm.itemAssignClick(item)
                                      }
                                    }
                                  },
                                  [_vm._v(" >> ")]
                                )
                              ]),
                              _c("el-input", {
                                staticClass: "item3",
                                class: { "textarea-red": item.redColor },
                                attrs: {
                                  rows: 6,
                                  type: "textarea",
                                  disabled: _vm.fieldEditCheck(item.code)
                                },
                                model: {
                                  value: _vm.doc.consignee,
                                  callback: function($$v) {
                                    _vm.$set(_vm.doc, "consignee", $$v)
                                  },
                                  expression: "doc.consignee"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFieldItem(
                        item,
                        _vm.SystemConstants.OCR_FIELD_NOTIFY.code
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("Message.Notify")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("el-input", {
                                    staticClass: "item2",
                                    class: { "textarea-red": item.redColor },
                                    attrs: {
                                      disabled: "",
                                      rows: 6,
                                      type: "textarea"
                                    },
                                    model: {
                                      value: _vm.resultJson[item.code],
                                      callback: function($$v) {
                                        _vm.$set(_vm.resultJson, item.code, $$v)
                                      },
                                      expression: "resultJson[item.code]"
                                    }
                                  })
                                : _vm._e(),
                              _c("div", { staticClass: "itemAssign" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.redColor,
                                        expression: "item.redColor"
                                      }
                                    ],
                                    staticClass: "itemAssign2",
                                    on: {
                                      click: function($event) {
                                        return _vm.itemAssignClick(item)
                                      }
                                    }
                                  },
                                  [_vm._v(" >> ")]
                                )
                              ]),
                              _c("el-input", {
                                staticClass: "item3",
                                class: { "textarea-red": item.redColor },
                                attrs: {
                                  rows: 6,
                                  type: "textarea",
                                  disabled: _vm.fieldEditCheck(item.code)
                                },
                                model: {
                                  value: _vm.doc.notify,
                                  callback: function($$v) {
                                    _vm.$set(_vm.doc, "notify", $$v)
                                  },
                                  expression: "doc.notify"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFieldItem(
                        item,
                        _vm.SystemConstants.OCR_FIELD_CARRIER.code
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.ShippingCompany"))
                                  )
                                ]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "item2",
                                      style: item.redColor ? "color:red" : ""
                                    },
                                    [_vm._v(_vm._s(_vm.resultJson[item.code]))]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "itemAssign" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.redColor,
                                        expression: "item.redColor"
                                      }
                                    ],
                                    staticClass: "itemAssign2",
                                    on: {
                                      click: function($event) {
                                        return _vm.itemAssignClick(item)
                                      }
                                    }
                                  },
                                  [_vm._v(" >> ")]
                                )
                              ]),
                              _c("cargo-company-select", {
                                staticClass: "item3",
                                class: { "input-red": item.redColor },
                                attrs: {
                                  "method-params": {
                                    companyLob: "seaExport",
                                    seaCmp: true,
                                    active: true
                                  },
                                  "default-value": _vm.doc.carrierId || "",
                                  placeholder: "",
                                  disabled: _vm.fieldEditCheck(item.code)
                                },
                                on: {
                                  clear: function($event) {
                                    return _vm.clear(item)
                                  },
                                  change: function(p) {
                                    _vm.pm.carrierChangeHandler(
                                      _vm.doc.dischargingPortCode,
                                      p.value
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFieldItem(
                        item,
                        _vm.SystemConstants.OCR_FIELD_VESSEL.code
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("Payment.vessel")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "item2",
                                      style: item.redColor ? "color:red" : ""
                                    },
                                    [_vm._v(_vm._s(_vm.resultJson[item.code]))]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "itemAssign" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.redColor,
                                        expression: "item.redColor"
                                      }
                                    ],
                                    staticClass: "itemAssign2",
                                    on: {
                                      click: function($event) {
                                        return _vm.itemAssignClick(item)
                                      }
                                    }
                                  },
                                  [_vm._v(" >> ")]
                                )
                              ]),
                              _c("cargo-advance-select", {
                                staticClass: "item3",
                                class: { "input-red": item.redColor },
                                attrs: {
                                  no: "vessel",
                                  "select-type":
                                    _vm.selectTypeNames.static_data_Vessel,
                                  cache: false,
                                  filterable: "",
                                  "allow-create": true,
                                  "default-value": _vm.doc.vessel,
                                  "static-options": _vm.vesselList,
                                  disabled: _vm.fieldEditCheck(item.code)
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.onVesselSelectionChange(p)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFieldItem(
                        item,
                        _vm.SystemConstants.OCR_FIELD_VOYAGE.code
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("Payment.voyage")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "item2",
                                      style: item.redColor ? "color:red" : ""
                                    },
                                    [_vm._v(_vm._s(_vm.resultJson[item.code]))]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "itemAssign" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.redColor,
                                        expression: "item.redColor"
                                      }
                                    ],
                                    staticClass: "itemAssign2",
                                    on: {
                                      click: function($event) {
                                        return _vm.itemAssignClick(item)
                                      }
                                    }
                                  },
                                  [_vm._v(" >> ")]
                                )
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "item3",
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "item3",
                                    class: { "input-red": item.redColor },
                                    attrs: {
                                      disabled: _vm.fieldEditCheck(item.code)
                                    },
                                    model: {
                                      value: _vm.doc.voyageFlight,
                                      callback: function($$v) {
                                        _vm.$set(_vm.doc, "voyageFlight", $$v)
                                      },
                                      expression: "doc.voyageFlight"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.showFieldItem(
                        item,
                        _vm.SystemConstants.OCR_FIELD_PAYMENT_TERM.code
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "block",
                                    width: "100%"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "item1",
                                          style: {
                                            color: _vm.getFieldColor(item)
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("SeaExport.FreightTerm")
                                            )
                                          )
                                        ]
                                      ),
                                      _vm.showBookRecognitionResults
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "item2 itemAssign",
                                              style: item.redColor
                                                ? "color:red"
                                                : ""
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.resultJson[item.code]
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _c("div", { staticClass: "itemAssign" }, [
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: item.redColor,
                                                expression: "item.redColor"
                                              }
                                            ],
                                            staticClass: "itemAssign2",
                                            on: {
                                              click: function($event) {
                                                return _vm.itemAssignClick(item)
                                              }
                                            }
                                          },
                                          [_vm._v(" >> ")]
                                        )
                                      ]),
                                      _c("cargo-advance-select", {
                                        staticClass: "item3",
                                        class: { "input-red": item.redColor },
                                        attrs: {
                                          "select-type":
                                            _vm.selectTypeNames
                                              .basic_data_PaymentTerm,
                                          filterable: "",
                                          clearable: "",
                                          "default-value":
                                            _vm.doc.paymentTermMBL,
                                          disabled: _vm.fieldEditCheck(
                                            item.code
                                          )
                                        },
                                        on: {
                                          clear: function($event) {
                                            return _vm.clear(item)
                                          },
                                          parentCallBack: function(p) {
                                            _vm.paymentTermMBL = p.value
                                            _vm.doc.paymentTermMBL = p.value
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.paymentTermMBL === "3P" &&
                                            _vm.source ===
                                              _vm.INTELLIGENT_DOCUMENT_SOURCE_5
                                                .code,
                                          expression:
                                            "paymentTermMBL === '3P' && source === INTELLIGENT_DOCUMENT_SOURCE_5.code"
                                        }
                                      ],
                                      staticStyle: { display: "flex" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "item1",
                                          style: {
                                            color: _vm.getFieldColor(item)
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("CargoMsg.Cargo_Payment1")
                                            )
                                          )
                                        ]
                                      ),
                                      _vm.showBookRecognitionResults
                                        ? _c("el-input", {
                                            staticClass: "item2",
                                            class: {
                                              "textarea-red": item.redColor
                                            },
                                            attrs: {
                                              value: "",
                                              disabled: "",
                                              rows: 6,
                                              type: "textarea"
                                            }
                                          })
                                        : _vm._e(),
                                      _c("div", { staticClass: "itemAssign" }, [
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: item.redColor,
                                                expression: "item.redColor"
                                              }
                                            ],
                                            staticClass: "itemAssign2",
                                            on: {
                                              click: function($event) {
                                                return _vm.itemAssignClick(item)
                                              }
                                            }
                                          },
                                          [_vm._v(" >> ")]
                                        )
                                      ]),
                                      _c("el-input", {
                                        staticClass: "item3",
                                        class: {
                                          "textarea-red": item.redColor
                                        },
                                        attrs: {
                                          rows: 6,
                                          type: "textarea",
                                          disabled: _vm.fieldEditCheck(
                                            item.code
                                          )
                                        },
                                        model: {
                                          value: _vm.doc.paymentData,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.doc,
                                              "paymentData",
                                              $$v
                                            )
                                          },
                                          expression: "doc.paymentData"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.showFieldItem(
                        item,
                        _vm.SystemConstants.OCR_FIELD_FREIGHT_TERM.code
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_TransitTerm"))
                                  )
                                ]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "item2",
                                      style: item.redColor ? "color:red" : ""
                                    },
                                    [_vm._v(_vm._s(_vm.resultJson[item.code]))]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "itemAssign" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.redColor,
                                        expression: "item.redColor"
                                      }
                                    ],
                                    staticClass: "itemAssign2",
                                    on: {
                                      click: function($event) {
                                        return _vm.itemAssignClick(item)
                                      }
                                    }
                                  },
                                  [_vm._v(" >> ")]
                                )
                              ]),
                              _c("cargo-advance-select", {
                                staticClass: "item3",
                                class: { "input-red": item.redColor },
                                attrs: {
                                  no: "freightTerm",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_ShippingTerm,
                                  filterable: "",
                                  disabled: _vm.fieldEditCheck(item.code),
                                  clearable: false,
                                  "default-value": _vm.doc.freightTerm || ""
                                },
                                on: {
                                  clear: function($event) {
                                    return _vm.clear(item)
                                  },
                                  parentCallBack: function(p) {
                                    _vm.doc.freightTerm = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFieldItem(
                        item,
                        _vm.SystemConstants.OCR_FIELD_CONTAINER_INFOS.code
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { display: "block" } },
                                    [
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_CartonQuantity"
                                            )
                                          )
                                        )
                                      ]),
                                      _c(
                                        "div",
                                        { staticStyle: { color: "#cbc7c7" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              "(" +
                                                _vm.$t(
                                                  "CargoMsg.Cargo_NotUpdate"
                                                ) +
                                                ")"
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "item2",
                                      style: item.redColor ? "color:red" : ""
                                    },
                                    [_vm._v(_vm._s(_vm.resultJson[item.code]))]
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  staticClass: "item3",
                                  class: { "input-red": item.redColor },
                                  staticStyle: { "overflow-y": "auto" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-direction": "column",
                                            "max-height": "200px"
                                          }
                                        },
                                        _vm._l(_vm.doc.seaEQ, function(
                                          item,
                                          index
                                        ) {
                                          return _c("div", { key: index }, [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: { display: "flex" }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      width: "49%"
                                                    }
                                                  },
                                                  [
                                                    _c("el-input-number", {
                                                      staticClass: "item3-1",
                                                      staticStyle: {
                                                        width: "40px"
                                                      },
                                                      attrs: {
                                                        disabled: true,
                                                        controls: false,
                                                        no: "eqQuantity"
                                                      },
                                                      model: {
                                                        value: item.eqQuantity,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "eqQuantity",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.eqQuantity"
                                                      }
                                                    }),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          "margin-left": "5px"
                                                        }
                                                      },
                                                      [_vm._v("X")]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      display: "flex"
                                                    }
                                                  },
                                                  [
                                                    _c("cargo-advance-select", {
                                                      staticClass: "item3-1",
                                                      staticStyle: {
                                                        width: "60px",
                                                        "margin-left": "5px"
                                                      },
                                                      attrs: {
                                                        no: "eqSize",
                                                        "select-type":
                                                          _vm.selectTypeNames
                                                            .local_cache_EQSize,
                                                        fields: ["code"],
                                                        filterable: "",
                                                        placeholder: " ",
                                                        "show-copy": false,
                                                        disabled: true,
                                                        "default-value":
                                                          item.eqSize,
                                                        "tag-name": "code"
                                                      },
                                                      on: {
                                                        parentCallBack: function(
                                                          p
                                                        ) {
                                                          _vm.changeSizeCallBack(
                                                            item,
                                                            p
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _c("cargo-advance-select", {
                                                      staticClass: "item3-1",
                                                      staticStyle: {
                                                        width: "60px",
                                                        "margin-left": "5px"
                                                      },
                                                      attrs: {
                                                        no: "eqType",
                                                        "select-type":
                                                          _vm.selectTypeNames
                                                            .basic_data_EQType,
                                                        fields: ["code"],
                                                        filterable: "",
                                                        placeholder: " ",
                                                        "show-copy": false,
                                                        disabled: true,
                                                        "default-value":
                                                          item.eqType,
                                                        "tag-name": "code"
                                                      },
                                                      on: {
                                                        parentCallBack: function(
                                                          p
                                                        ) {
                                                          _vm.changeTypeCallBack(
                                                            item,
                                                            p
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ])
                                        }),
                                        0
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.showFieldItem(
                        item,
                        _vm.SystemConstants.OCR_FIELD_PAYMENT_PLACE_BL.code
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.PlaceOfPayment"))
                                  )
                                ]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "item2",
                                      style: item.redColor ? "color:red" : ""
                                    },
                                    [_vm._v(_vm._s(_vm.resultJson[item.code]))]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "itemAssign" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.redColor,
                                        expression: "item.redColor"
                                      }
                                    ],
                                    staticClass: "itemAssign2",
                                    on: {
                                      click: function($event) {
                                        return _vm.itemAssignClick(item)
                                      }
                                    }
                                  },
                                  [_vm._v(" >> ")]
                                )
                              ]),
                              _c("el-input", {
                                staticClass: "item3",
                                class: { "input-red": item.redColor },
                                attrs: {
                                  disabled: _vm.fieldEditCheck(item.code)
                                },
                                model: {
                                  value: _vm.doc.paymentPlaceBL,
                                  callback: function($$v) {
                                    _vm.$set(_vm.doc, "paymentPlaceBL", $$v)
                                  },
                                  expression: "doc.paymentPlaceBL"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFieldItem(
                        item,
                        _vm.SystemConstants.OCR_FIELD_TD_SIGN_PLACE_BL.code
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.PlaceOfIssue"))
                                  )
                                ]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "item2",
                                      style: item.redColor ? "color:red" : ""
                                    },
                                    [_vm._v(_vm._s(_vm.resultJson[item.code]))]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "itemAssign" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.redColor,
                                        expression: "item.redColor"
                                      }
                                    ],
                                    staticClass: "itemAssign2",
                                    on: {
                                      click: function($event) {
                                        return _vm.itemAssignClick(item)
                                      }
                                    }
                                  },
                                  [_vm._v(" >> ")]
                                )
                              ]),
                              _c("el-input", {
                                staticClass: "item3",
                                class: { "input-red": item.redColor },
                                attrs: {
                                  disabled: _vm.fieldEditCheck(item.code)
                                },
                                model: {
                                  value: _vm.doc.signPlaceBL,
                                  callback: function($$v) {
                                    _vm.$set(_vm.doc, "signPlaceBL", $$v)
                                  },
                                  expression: "doc.signPlaceBL"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFieldItem(
                        item,
                        _vm.SystemConstants.OCR_FIELD_TD_SIGN_DATE_BL.code
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.DateOfIssue"))
                                  )
                                ]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "item2",
                                      style: item.redColor ? "color:red" : ""
                                    },
                                    [_vm._v(_vm._s(_vm.resultJson[item.code]))]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "itemAssign" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.redColor,
                                        expression: "item.redColor"
                                      }
                                    ],
                                    staticClass: "itemAssign2",
                                    on: {
                                      click: function($event) {
                                        return _vm.itemAssignClick(item)
                                      }
                                    }
                                  },
                                  [_vm._v(" >> ")]
                                )
                              ]),
                              _c("el-date-picker", {
                                staticClass: "item3",
                                class: { "input-red": item.redColor },
                                attrs: {
                                  value: _vm.doc.signDateBL,
                                  type: "date",
                                  "value-format": "yyyy-MM-dd",
                                  disabled: _vm.fieldEditCheck(item.code)
                                },
                                on: { input: _vm.signDateBLChange }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFieldItem(
                        item,
                        _vm.SystemConstants.OCR_FIELD_HS_CODE.code
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.HsCode")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("el-input", {
                                    staticClass: "item2",
                                    class: { "textarea-red": item.redColor },
                                    attrs: {
                                      disabled: "",
                                      rows: 6,
                                      type: "textarea"
                                    },
                                    model: {
                                      value: _vm.resultJson[item.code],
                                      callback: function($$v) {
                                        _vm.$set(_vm.resultJson, item.code, $$v)
                                      },
                                      expression: "resultJson[item.code]"
                                    }
                                  })
                                : _vm._e(),
                              _c("div", { staticClass: "itemAssign" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.redColor,
                                        expression: "item.redColor"
                                      }
                                    ],
                                    staticClass: "itemAssign2",
                                    on: {
                                      click: function($event) {
                                        return _vm.itemAssignClick(item)
                                      }
                                    }
                                  },
                                  [_vm._v(" >> ")]
                                )
                              ]),
                              _c("el-input", {
                                staticClass: "item3",
                                class: { "textarea-red": item.redColor },
                                attrs: {
                                  rows: 6,
                                  type: "textarea",
                                  disabled: _vm.fieldEditCheck(item.code)
                                },
                                model: {
                                  value: _vm.doc.hsCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.doc, "hsCode", $$v)
                                  },
                                  expression: "doc.hsCode"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFieldItem(
                        item,
                        _vm.SystemConstants.OCR_FIELD_DISPATCHING_PLACE.code
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.PlaceOfReceiptOnBl")
                                    )
                                  )
                                ]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "item2",
                                      style: item.redColor ? "color:red" : ""
                                    },
                                    [_vm._v(_vm._s(_vm.resultJson[item.code]))]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "itemAssign" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.redColor,
                                        expression: "item.redColor"
                                      }
                                    ],
                                    staticClass: "itemAssign2",
                                    on: {
                                      click: function($event) {
                                        return _vm.itemAssignClick(item)
                                      }
                                    }
                                  },
                                  [_vm._v(" >> ")]
                                )
                              ]),
                              _c("el-input", {
                                staticClass: "item3",
                                class: { "input-red": item.redColor },
                                attrs: {
                                  disabled: _vm.fieldEditCheck(item.code)
                                },
                                model: {
                                  value: _vm.doc.dispatchingPlace,
                                  callback: function($$v) {
                                    _vm.$set(_vm.doc, "dispatchingPlace", $$v)
                                  },
                                  expression: "doc.dispatchingPlace"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFieldItem(
                        item,
                        _vm.SystemConstants.OCR_FIELD_LOADING_PORT.code
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.PortOfLoadingOnBl")
                                    )
                                  )
                                ]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "item2",
                                      style: item.redColor ? "color:red" : ""
                                    },
                                    [_vm._v(_vm._s(_vm.resultJson[item.code]))]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "itemAssign" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.redColor,
                                        expression: "item.redColor"
                                      }
                                    ],
                                    staticClass: "itemAssign2",
                                    on: {
                                      click: function($event) {
                                        return _vm.itemAssignClick(item)
                                      }
                                    }
                                  },
                                  [_vm._v(" >> ")]
                                )
                              ]),
                              _c("el-input", {
                                staticClass: "item3",
                                class: { "input-red": item.redColor },
                                attrs: {
                                  disabled: _vm.fieldEditCheck(item.code)
                                },
                                model: {
                                  value: _vm.doc.loadingPort,
                                  callback: function($$v) {
                                    _vm.$set(_vm.doc, "loadingPort", $$v)
                                  },
                                  expression: "doc.loadingPort"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFieldItem(
                        item,
                        _vm.SystemConstants.OCR_FIELD_DISCHARGING_PORT.code
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.PortOfDischargeOnBl")
                                    )
                                  )
                                ]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "item2",
                                      style: item.redColor ? "color:red" : ""
                                    },
                                    [_vm._v(_vm._s(_vm.resultJson[item.code]))]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "itemAssign" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.redColor,
                                        expression: "item.redColor"
                                      }
                                    ],
                                    staticClass: "itemAssign2",
                                    on: {
                                      click: function($event) {
                                        return _vm.itemAssignClick(item)
                                      }
                                    }
                                  },
                                  [_vm._v(" >> ")]
                                )
                              ]),
                              _c("el-input", {
                                staticClass: "item3",
                                class: { "input-red": item.redColor },
                                attrs: {
                                  disabled: _vm.fieldEditCheck(item.code)
                                },
                                model: {
                                  value: _vm.doc.dischargingPort,
                                  callback: function($$v) {
                                    _vm.$set(_vm.doc, "dischargingPort", $$v)
                                  },
                                  expression: "doc.dischargingPort"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFieldItem(
                        item,
                        _vm.SystemConstants.OCR_FIELD_DESTINATION_PORT.code
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.PlaceOfDeliveryOnBl")
                                    )
                                  )
                                ]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "item2",
                                      style: item.redColor ? "color:red" : ""
                                    },
                                    [_vm._v(_vm._s(_vm.resultJson[item.code]))]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "itemAssign" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.redColor,
                                        expression: "item.redColor"
                                      }
                                    ],
                                    staticClass: "itemAssign2",
                                    on: {
                                      click: function($event) {
                                        return _vm.itemAssignClick(item)
                                      }
                                    }
                                  },
                                  [_vm._v(" >> ")]
                                )
                              ]),
                              _c("el-input", {
                                staticClass: "item3",
                                class: { "input-red": item.redColor },
                                attrs: {
                                  disabled: _vm.fieldEditCheck(item.code)
                                },
                                model: {
                                  value: _vm.doc.destinationPort,
                                  callback: function($$v) {
                                    _vm.$set(_vm.doc, "destinationPort", $$v)
                                  },
                                  expression: "doc.destinationPort"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFieldItem(
                        item,
                        _vm.SystemConstants.OCR_FIELD_TD_QUANTITY.code
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Quantity")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "item2",
                                      style: item.redColor ? "color:red" : ""
                                    },
                                    [_vm._v(_vm._s(_vm.resultJson[item.code]))]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "itemAssign" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.redColor,
                                        expression: "item.redColor"
                                      }
                                    ],
                                    staticClass: "itemAssign2",
                                    on: {
                                      click: function($event) {
                                        return _vm.itemAssignClick(item)
                                      }
                                    }
                                  },
                                  [_vm._v(" >> ")]
                                )
                              ]),
                              _c("el-input-number", {
                                staticClass: "item3",
                                class: { "input-red": item.redColor },
                                attrs: {
                                  controls: false,
                                  no: "quantityContract",
                                  disabled: _vm.fieldEditCheck(item.code)
                                },
                                model: {
                                  value: _vm.doc.quantity,
                                  callback: function($$v) {
                                    _vm.$set(_vm.doc, "quantity", $$v)
                                  },
                                  expression: "doc.quantity"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFieldItem(
                        item,
                        _vm.SystemConstants.OCR_FIELD_PACKING.code
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Package")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "item2",
                                      style: item.redColor ? "color:red" : ""
                                    },
                                    [_vm._v(_vm._s(_vm.resultJson[item.code]))]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "itemAssign" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.redColor,
                                        expression: "item.redColor"
                                      }
                                    ],
                                    staticClass: "itemAssign2",
                                    on: {
                                      click: function($event) {
                                        return _vm.itemAssignClick(item)
                                      }
                                    }
                                  },
                                  [_vm._v(" >> ")]
                                )
                              ]),
                              _c("cargo-packing-select", {
                                staticClass: "item3",
                                class: { "input-red": item.redColor },
                                attrs: {
                                  no: "packing",
                                  "default-value": _vm.doc.packing,
                                  placeholder: "",
                                  disabled: _vm.fieldEditCheck(item.code)
                                },
                                on: {
                                  clear: function($event) {
                                    return _vm.clear(item)
                                  },
                                  change: function(p) {
                                    _vm.doc.packing = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFieldItem(
                        item,
                        _vm.SystemConstants.OCR_FIELD_INSIDE_QUANTITY.code
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Pieces2")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "item2",
                                      style: item.redColor ? "color:red" : ""
                                    },
                                    [_vm._v(_vm._s(_vm.resultJson[item.code]))]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "itemAssign" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.redColor,
                                        expression: "item.redColor"
                                      }
                                    ],
                                    staticClass: "itemAssign2",
                                    on: {
                                      click: function($event) {
                                        return _vm.itemAssignClick(item)
                                      }
                                    }
                                  },
                                  [_vm._v(" >> ")]
                                )
                              ]),
                              _c("el-input-number", {
                                staticClass: "item3",
                                class: { "input-red": item.redColor },
                                attrs: {
                                  controls: false,
                                  no: "insideQuantity",
                                  disabled: _vm.fieldEditCheck(item.code)
                                },
                                model: {
                                  value: _vm.doc.insideQuantity,
                                  callback: function($$v) {
                                    _vm.$set(_vm.doc, "insideQuantity", $$v)
                                  },
                                  expression: "doc.insideQuantity"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFieldItem(
                        item,
                        _vm.SystemConstants.OCR_FIELD_INSIDE_PACKING.code
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.PiecesType2"))
                                  )
                                ]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "item2",
                                      style: item.redColor ? "color:red" : ""
                                    },
                                    [_vm._v(_vm._s(_vm.resultJson[item.code]))]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "itemAssign" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.redColor,
                                        expression: "item.redColor"
                                      }
                                    ],
                                    staticClass: "itemAssign2",
                                    on: {
                                      click: function($event) {
                                        return _vm.itemAssignClick(item)
                                      }
                                    }
                                  },
                                  [_vm._v(" >> ")]
                                )
                              ]),
                              _c("cargo-packing-select", {
                                staticClass: "item3",
                                class: { "color-red": item.redColor },
                                attrs: {
                                  no: "packing",
                                  "default-value": _vm.doc.insidePacking,
                                  placeholder: "",
                                  disabled: _vm.fieldEditCheck(item.code)
                                },
                                on: {
                                  clear: function($event) {
                                    return _vm.clear(item)
                                  },
                                  change: function(p) {
                                    _vm.doc.insidePacking = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFieldItem(
                        item,
                        _vm.SystemConstants.OCR_FIELD_TD_WEIGHT.code
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Weight")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "item2",
                                      style: item.redColor ? "color:red" : ""
                                    },
                                    [_vm._v(_vm._s(_vm.resultJson[item.code]))]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "itemAssign" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.redColor,
                                        expression: "item.redColor"
                                      }
                                    ],
                                    staticClass: "itemAssign2",
                                    on: {
                                      click: function($event) {
                                        return _vm.itemAssignClick(item)
                                      }
                                    }
                                  },
                                  [_vm._v(" >> ")]
                                )
                              ]),
                              _c("el-input-number", {
                                staticClass: "item3",
                                class: { "input-red": item.redColor },
                                attrs: {
                                  controls: false,
                                  no: "weight",
                                  disabled: _vm.fieldEditCheck(item.code)
                                },
                                model: {
                                  value: _vm.doc.weight,
                                  callback: function($$v) {
                                    _vm.$set(_vm.doc, "weight", $$v)
                                  },
                                  expression: "doc.weight"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFieldItem(
                        item,
                        _vm.SystemConstants.OCR_FIELD_TD_CUBAGE.code
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Cubage")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "item2",
                                      style: item.redColor ? "color:red" : ""
                                    },
                                    [_vm._v(_vm._s(_vm.resultJson[item.code]))]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "itemAssign" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.redColor,
                                        expression: "item.redColor"
                                      }
                                    ],
                                    staticClass: "itemAssign2",
                                    on: {
                                      click: function($event) {
                                        return _vm.itemAssignClick(item)
                                      }
                                    }
                                  },
                                  [_vm._v(" >> ")]
                                )
                              ]),
                              _c("el-input-number", {
                                staticClass: "item3",
                                class: { "input-red": item.redColor },
                                attrs: {
                                  controls: false,
                                  no: "cubage",
                                  disabled: _vm.fieldEditCheck(item.code)
                                },
                                model: {
                                  value: _vm.doc.cubage,
                                  callback: function($$v) {
                                    _vm.$set(_vm.doc, "cubage", $$v)
                                  },
                                  expression: "doc.cubage"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFieldItem(
                        item,
                        _vm.SystemConstants.OCR_FIELD_MARK.code
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Marks")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("el-input", {
                                    staticClass: "item2",
                                    class: { "textarea-red": item.redColor },
                                    attrs: {
                                      disabled: "",
                                      rows: 6,
                                      type: "textarea"
                                    },
                                    model: {
                                      value: _vm.resultJson[item.code],
                                      callback: function($$v) {
                                        _vm.$set(_vm.resultJson, item.code, $$v)
                                      },
                                      expression: "resultJson[item.code]"
                                    }
                                  })
                                : _vm._e(),
                              _c("div", { staticClass: "itemAssign" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.redColor,
                                        expression: "item.redColor"
                                      }
                                    ],
                                    staticClass: "itemAssign2",
                                    on: {
                                      click: function($event) {
                                        return _vm.itemAssignClick(item)
                                      }
                                    }
                                  },
                                  [_vm._v(" >> ")]
                                )
                              ]),
                              _c("el-input", {
                                staticClass: "item3",
                                class: { "textarea-red": item.redColor },
                                attrs: {
                                  rows: 6,
                                  type: "textarea",
                                  no: "mark",
                                  disabled: _vm.fieldEditCheck(item.code)
                                },
                                model: {
                                  value: _vm.doc.mark,
                                  callback: function($$v) {
                                    _vm.$set(_vm.doc, "mark", $$v)
                                  },
                                  expression: "doc.mark"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFieldItem(
                        item,
                        _vm.SystemConstants.OCR_FIELD_GOOD_NAME.code
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("Pricing.Goods")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("el-input", {
                                    staticClass: "item2",
                                    class: { "textarea-red": item.redColor },
                                    attrs: {
                                      disabled: "",
                                      rows: 6,
                                      type: "textarea"
                                    },
                                    model: {
                                      value: _vm.resultJson[item.code],
                                      callback: function($$v) {
                                        _vm.$set(_vm.resultJson, item.code, $$v)
                                      },
                                      expression: "resultJson[item.code]"
                                    }
                                  })
                                : _vm._e(),
                              _c("div", { staticClass: "itemAssign" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.redColor,
                                        expression: "item.redColor"
                                      }
                                    ],
                                    staticClass: "itemAssign2",
                                    on: {
                                      click: function($event) {
                                        return _vm.itemAssignClick(item)
                                      }
                                    }
                                  },
                                  [_vm._v(" >> ")]
                                )
                              ]),
                              _c("el-input", {
                                staticClass: "item3",
                                class: { "textarea-red": item.redColor },
                                attrs: {
                                  rows: 6,
                                  type: "textarea",
                                  no: "cargoEnglishName",
                                  disabled: _vm.fieldEditCheck(item.code)
                                },
                                model: {
                                  value: _vm.doc.cargoEnglishName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.doc, "cargoEnglishName", $$v)
                                  },
                                  expression: "doc.cargoEnglishName"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFieldItem(
                        item,
                        _vm.SystemConstants.OCR_FIELD_REMARKS.code
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("Payment.remarks")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("el-input", {
                                    staticClass: "item2",
                                    class: { "textarea-red": item.redColor },
                                    attrs: {
                                      disabled: "",
                                      rows: 6,
                                      type: "textarea"
                                    },
                                    model: {
                                      value: _vm.resultJson[item.code],
                                      callback: function($$v) {
                                        _vm.$set(_vm.resultJson, item.code, $$v)
                                      },
                                      expression: "resultJson[item.code]"
                                    }
                                  })
                                : _vm._e(),
                              _c("div", { staticClass: "itemAssign" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.redColor,
                                        expression: "item.redColor"
                                      }
                                    ],
                                    staticClass: "itemAssign2",
                                    on: {
                                      click: function($event) {
                                        return _vm.itemAssignClick(item)
                                      }
                                    }
                                  },
                                  [_vm._v(" >> ")]
                                )
                              ]),
                              _c("el-input", {
                                staticClass: "item3",
                                class: { "textarea-red": item.redColor },
                                attrs: {
                                  rows: 6,
                                  type: "textarea",
                                  no: "remarks",
                                  disabled: _vm.fieldEditCheck(item.code)
                                },
                                model: {
                                  value: _vm.doc.remarks,
                                  callback: function($$v) {
                                    _vm.$set(_vm.doc, "remarks", $$v)
                                  },
                                  expression: "doc.remarks"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_CONTAINER_DATA.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "block",
                                    width: "100%",
                                    position: "relative"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        position: "absolute",
                                        top: "6px",
                                        padding: "2px",
                                        "background-color": "#169bd5",
                                        cursor: "pointer",
                                        color: "#169bd5"
                                      }
                                    },
                                    [_vm._v(_vm._s("."))]
                                  ),
                                  _c(
                                    "div",
                                    { staticStyle: { padding: "10px" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_ContainerIdTip"
                                            )
                                          )
                                      )
                                    ]
                                  ),
                                  _c("table", { staticClass: "table" }, [
                                    _c("thead", [
                                      _c(
                                        "tr",
                                        {
                                          staticClass: "gray-row",
                                          staticStyle: { height: "30px" }
                                        },
                                        [
                                          _c("td", {
                                            staticClass: "centered-cell"
                                          }),
                                          _c(
                                            "td",
                                            { staticClass: "centered-cell" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "SeaExport.ChargeSource"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            { staticClass: "centered-cell" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "SeaExport.ContainerNo"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            { staticClass: "centered-cell" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("SeaExport.BoxType")
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            { staticClass: "centered-cell" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("SeaExport.SealNo")
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            { staticClass: "centered-cell" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("SeaExport.itemCount")
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            { staticClass: "centered-cell" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("SeaExport.Package")
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            { staticClass: "centered-cell" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("SeaExport.Weight2")
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            { staticClass: "centered-cell" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("SeaExport.Cubage")
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]),
                                    _c(
                                      "tbody",
                                      _vm._l(_vm.doc.container, function(
                                        item,
                                        index
                                      ) {
                                        return _c("tr", { key: index }, [
                                          _c(
                                            "td",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: item.showCheck > 0,
                                                  expression:
                                                    "item.showCheck > 0"
                                                }
                                              ],
                                              staticClass: "centered-cell",
                                              staticStyle: { width: "5%" },
                                              attrs: {
                                                rowspan: Number(item.showCheck)
                                              }
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: item.checked,
                                                    expression: "item.checked"
                                                  }
                                                ],
                                                attrs: { type: "checkbox" },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    item.checked
                                                  )
                                                    ? _vm._i(
                                                        item.checked,
                                                        null
                                                      ) > -1
                                                    : item.checked
                                                },
                                                on: {
                                                  change: function($event) {
                                                    var $$a = item.checked,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          _vm.$set(
                                                            item,
                                                            "checked",
                                                            $$a.concat([$$v])
                                                          )
                                                      } else {
                                                        $$i > -1 &&
                                                          _vm.$set(
                                                            item,
                                                            "checked",
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              )
                                                          )
                                                      }
                                                    } else {
                                                      _vm.$set(
                                                        item,
                                                        "checked",
                                                        $$c
                                                      )
                                                    }
                                                  }
                                                }
                                              })
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            {
                                              staticClass: "centered-cell",
                                              staticStyle: { width: "10%" }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  item.chargeSource
                                                    ? _vm.$t(
                                                        "CargoMsg.Cargo_RecognitionData"
                                                      )
                                                    : _vm.$t(
                                                        "CargoMsg.Cargo_SystemData"
                                                      )
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            {
                                              staticClass: "centered-cell",
                                              staticStyle: { width: "15%" }
                                            },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  disabled: _vm.fieldEditCheck(
                                                    "container_containerNo"
                                                  ),
                                                  no: "containerNo"
                                                },
                                                on: {
                                                  change:
                                                    _vm.containerNoChargeHandler
                                                },
                                                model: {
                                                  value: item.containerNo,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "containerNo",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.containerNo"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "td",
                                            {
                                              staticClass: "centered-cell",
                                              staticStyle: { width: "10%" }
                                            },
                                            [_vm._v(_vm._s(item.eqSizeStr))]
                                          ),
                                          _c(
                                            "td",
                                            {
                                              staticClass: "centered-cell",
                                              staticStyle: { width: "15%" }
                                            },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  disabled: _vm.fieldEditCheck(
                                                    "container_sealNo"
                                                  ),
                                                  no: "sealNo"
                                                },
                                                model: {
                                                  value: item.sealNo,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "sealNo",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.sealNo"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "td",
                                            {
                                              staticClass: "centered-cell",
                                              staticStyle: { width: "10%" }
                                            },
                                            [
                                              _c("auto-number-input", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  no: "quantity",
                                                  disabled: _vm.fieldEditCheck(
                                                    "container_quantity"
                                                  ),
                                                  precision: 0,
                                                  min: 0
                                                },
                                                model: {
                                                  value: item.quantity,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "quantity",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.quantity"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "td",
                                            {
                                              staticClass: "centered-cell",
                                              staticStyle: { width: "15%" }
                                            },
                                            [
                                              _c("cargo-advance-select", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  no: "packing",
                                                  "select-type":
                                                    _vm.TYPE_NAMES
                                                      .basic_data_Packing,
                                                  filterable: "",
                                                  disabled: _vm.fieldEditCheck(
                                                    "container_packing"
                                                  ),
                                                  "default-value": item.packing
                                                },
                                                on: {
                                                  parentCallBack: function(p) {
                                                    item.packing = p.value
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "td",
                                            {
                                              staticClass: "centered-cell",
                                              staticStyle: { width: "10%" }
                                            },
                                            [
                                              _c("auto-number-input", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  no: "weight",
                                                  disabled: _vm.fieldEditCheck(
                                                    "container_weight"
                                                  ),
                                                  precision: 3,
                                                  min: 0
                                                },
                                                model: {
                                                  value: item.weight,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "weight",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.weight"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "td",
                                            {
                                              staticClass: "centered-cell",
                                              staticStyle: { width: "10%" }
                                            },
                                            [
                                              _c("auto-number-input", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  no: "cubage",
                                                  disabled: _vm.fieldEditCheck(
                                                    "container_cubage"
                                                  ),
                                                  precision: 3,
                                                  min: 0
                                                },
                                                model: {
                                                  value: item.cubage,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "cubage",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.cubage"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ])
                                      }),
                                      0
                                    )
                                  ]),
                                  _c("div", {
                                    staticStyle: { "padding-top": "10px" }
                                  })
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  }),
                  0
                )
              : _vm._e()
          ]
        )
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            no: "fieldValidDialog",
            visible: _vm.fieldValidDialog.visible,
            title: _vm.$t("Message.WarmReminder"),
            width: "630px",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.fieldValidDialog, "visible", $event)
            }
          }
        },
        [
          _vm._l(_vm.fieldValidDialog.fieldValidResults, function(
            fieldValidResultByBook,
            index
          ) {
            return _c(
              "div",
              { key: index },
              [
                _c("div", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("CargoMsg.Cargo_Book") +
                        (fieldValidResultByBook.index + 1)
                    )
                  )
                ]),
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { data: fieldValidResultByBook.data }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "fieldName",
                        label: _vm.$t("CargoMsg.Cargo_FieldName"),
                        width: "180"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "exceptionReason",
                        label: _vm.$t("CargoMsg.Cargo_ErrorCause"),
                        width: "400"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          }),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.fieldValidDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Message.GotIt")))]
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }